import { MenuItem } from '@/types/menu';

export function menuItemRel(item: MenuItem): string | undefined {
  const rel = [];
  if (item.options.noFollow) {
    rel.push('nofollow');
  }
  if (item.options.noOpener) {
    rel.push('noopener');
  }
  if (item.options.noReferrer) {
    rel.push('noreferrer');
  }
  return rel.length > 0 ? rel.join(' ') : undefined;
}

export function maybeIsInternalUrl(url: string): boolean {
  if (typeof window === 'undefined') return false;

  const isAbsolute = /^(?:[a-z]+:)?\/\//i.test(url);
  const isAdminPath = url === '/admin' || url.startsWith('/admin/');

  if (isAdminPath) {
    return false;
  }

  if (isAbsolute) {
    try {
      const parsedUrl = new URL(url);

      if (parsedUrl.pathname === '/admin' || parsedUrl.pathname.startsWith('/admin/')) {
        return false;
      }
    } catch {}
  }

  return isAbsolute ? url.startsWith(window.location.origin) : true;
}

export function toAbsoluteUrl(url: string): string {
  if (typeof window === 'undefined') return url;

  if (maybeIsInternalUrl(url)) {
    return url.startsWith('http') ? url : `${window.location.origin}${url}`;
  }

  return url;
}

export function toRelativeUrl(url: string): string {
  if (typeof window === 'undefined') return url;

  return url.replace(window.location.origin, '');
}
